'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # isInteger
 * Number.isInteger() polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
 *
 * @param {Number} value
 * @return  {Boolean}
 *
 * @example
 * isInteger(4);
 *
 * @module helpers/util/is-integer.js
 */
function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}

exports.default = isInteger;
module.exports = exports['default'];
//# sourceMappingURL=is-integer.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/helpers/util/is-integer.js
// module id = 813
// module chunks = 0